// src/pages/common-components/Auth/Login.tsx
import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../Contexts/AuthContext';
import { AuthCard, AuthError, AuthSuccess, authInputStyle, authLabelStyle, authSubmitStyle, friendlyAuthError } from './AuthShared';

const Login: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  // Land on the profile page after signing in by default — unless a
  // protected route sent the user here with a specific place to return to.
  const state = location.state as { from?: string; justSignedUp?: boolean } | null;
  const redirectTo = state?.from || '/account';
  const justSignedUp = state?.justSignedUp || false;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim() || !password) {
      setError('Please enter your email and password.');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      await login(email.trim(), password);
      navigate(redirectTo, { replace: true });
    } catch (err: any) {
      setError(friendlyAuthError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthCard title="Sign In" subtitle="Welcome back — sign in to your account">
      <form onSubmit={handleSubmit}>
        <AuthError message={error} />
        {!error && justSignedUp && <AuthSuccess message="Account created! Please sign in." />}

        <div style={{ marginBottom: 18 }}>
          <label style={authLabelStyle}>Email Address</label>
          <input
            type="email"
            style={authInputStyle}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            autoComplete="email"
          />
        </div>

        <div style={{ marginBottom: 10 }}>
          <label style={authLabelStyle}>Password</label>
          <input
            type="password"
            style={authInputStyle}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            autoComplete="current-password"
          />
        </div>

        <div style={{ textAlign: 'right', marginBottom: 22 }}>
          <Link to="/forgot-password" style={{ fontSize: 13, color: '#717fe0' }}>
            Forgot password?
          </Link>
        </div>

        <button type="submit" style={{ ...authSubmitStyle, opacity: submitting ? 0.7 : 1 }} disabled={submitting}>
          {submitting ? 'Signing In…' : 'Sign In'}
        </button>

        <p style={{ textAlign: 'center', fontSize: 14, color: '#666', marginTop: 22, marginBottom: 0 }}>
          Don't have an account? <Link to="/signup" style={{ color: '#717fe0', fontWeight: 600 }}>Sign Up</Link>
        </p>
      </form>
    </AuthCard>
  );
};

export default Login;
